import React from 'react';
import Fade from 'react-reveal/Fade';

import Countdown from 'react-countdown-now';

import './MultipleChoiceMultiInteraction.css';

import { Button } from '@material-ui/core';

import {Col, Row} from 'reactstrap';

// toast
import 'react-toastify/dist/ReactToastify.css';

// toast component
import { toast, ToastContainer} from 'react-toastify';
import CustomCheckbox from '../../common/CustomCheckbox'

import {createItemJson, currentLessonAttempt, currentLesson} from '../../common/services';

import {dateToString} from '../../common/utils';

interface Istate {
  completiontext: any;
  demomode: boolean;
  oncomplete: any;
  interactionid: any,
  introtext: any;
  lessonid: any;
  penalty: number;
  question: any;
  answers: any;
  show: boolean;
  submittext: any;
  timelimit: number;
}

function randomId () {
    const reqlen = 5;
    let text = "tempdf_";
    const possible = "abcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < reqlen; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

class MultipleChoiceMultiInteraction extends React.Component<Istate> {

  public state = {
    answer: true,
    answers: [] as any[],
    completed: false,
    completiontext: this.props.completiontext,
    correctanscount: 0,
    demomode: this.props.demomode,
    introtext: this.props.introtext,
    penalty: this.props.penalty,
    question: this.props.question,
    quiz: false,
    quizlaunchtime: Date.now() + 5000,
    tries: 1,
    selections: {} as any,
    score: 0,
    show: false,
    showTimer: false,
    timelimit: this.props.timelimit * 1000,
    buttonDisabled: false
  }

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.process = this.process.bind(this);
    this.handleAnswerSelected = this.handleAnswerSelected.bind(this);

    const tempans = [] as any[];

    let correctans = 0;

    for (const answer of this.props.answers) {
        answer.ischecked = false;
        tempans.push(answer)

        if (answer.is_correct_answer) {
            correctans += 1;
        }
    }

    this.setState({answers: tempans, correctanscount: correctans})
  }

  public handleClick() {
    this.setState({ show: !this.state.show });
  }

  public handleAnswerSelected(idx, event) {
    console.log(event.currentTarget.value);
    console.log('idx: '+ idx);
    console.log('check: ' + event.target.checked)

    this.state.selections[idx] =  event.target.checked;

    console.log(this.state.selections);

    // const newtries = this.state.tries + 1;
    // this.setState({tries: newtries});
    // console.log('newtries: ' + this.state.tries);
  }

  public handleGenCreatedItemLoaded (res) {
    console.log(res);
    if(res.code ===200 || res.code ===201){ 
      this.setState({completed: true, disabledButton: true})

      toast(this.state.completiontext)

      setTimeout(this.props.oncomplete(), 1500);
    }
    else {
      toast.error('Error occurred, please try again')
    }
  }


  public process() {
    const item = {
      time_start: dateToString(this.state.quizlaunchtime),
      time_end: dateToString(Date.now()),
      tries_count: this.state.tries,
      lesson: this.props.lessonid,
      interaction: this.props.interactionid,
      answer: [] as any []
    }

    for (const objkey of Object.keys(this.state.selections)) {
      if(this.state.selections[objkey] === true) {
        item.answer.push(this.props.answers[objkey].id)
        console.log('found selection:' + this.props.answers[objkey])
      }
    }

    
    if (!this.state.demomode) {
      const currentlesson = currentLesson();
      createItemJson( 'interaction_attempts/?attemptid=' + currentlesson.sessionKey, item, text => this.handleGenCreatedItemLoaded(text));
    }
    else {
      // toast.info(this.props.completiontext);
      setTimeout(this.props.oncomplete(), 1500);
    }
  
    console.log(item);

  }

  public render() {

    const grid = 8;

    return (
      <div
        style={{ color: "white" }}
        className="multichoice-component-container"
      >
        <div className="multichoice-exercise-details">
          <Fade when={!this.state.quiz}>
            <p className="multichoice-intro-text">{this.props.introtext}</p>
          </Fade>

          <Fade when={this.state.quiz && !this.state.completed}>
            <div>
              <p className="multichoice-question">{this.state.question}</p>

              <ul>
                {this.props.answers.map((answer, idx) => (
                  <li className="multichoice-answer" key={idx}>
                    {/* <input
                      id={idx}
                      onChange={this.handleAnswerSelected.bind(this, idx)}
                      // className="modded-input"
                      className="choice"
                      type="checkbox"
                      name="answer"
                      value={answer.answer_text}
                    /> */}
                    <CustomCheckbox 
                      type="checkbox"
                      id={idx}
                      name="answer"
                      dispvalue={answer.answer_text}
                      value={answer.id}
                      onChange = {this.handleAnswerSelected.bind(this, idx)}
                    />
                    {/* <label htmlFor={idx}>{answer.answer_text}</label> */}
                  </li>
                ))}
              </ul>

              <Fade when={this.state.completed}>
                <div>
                  <p className="exercise-complete">
                    {this.state.completiontext}
                  </p>
                </div>
              </Fade>
            </div>
          </Fade>
          <Fade when={this.state.quiz}>
            <button
              className="blue-button submit-interaction submit-multichoice"
              onClick={this.process}
              disabled={this.state.buttonDisabled}
              style={{ display: this.state.quiz ? "initial" : "none" }}
            >
              {this.props.submittext}
            </button>
          </Fade>
        </div>

        <Fade when={this.state.show === false}>
          <div className="multichoice-duration-details">
            <p className="right">
              Your quiz begins in:
              <Countdown
                date={this.state.quizlaunchtime}
                // tslint:disable-next-line jsx-no-lambda
                onComplete={() => {
                  this.setState({
                    show: true,
                    quiz: true,
                    showTimer: true
                  });
                }}
              />
            </p>
          </div>
        </Fade>
      </div>
    );
  }
}
export default MultipleChoiceMultiInteraction;



// WEBPACK FOOTER //
// ./src/components/MultipleChoiceMultiInteraction/MultipleChoiceMultiInteraction.Component.tsx